import { NUMERIC_MEDIA_SIZES } from '../../../common/styles/vars';

export const isListMobile = (size) => size < NUMERIC_MEDIA_SIZES.small;